export const FILTER_SHOW_FILTER = "FILTER_FFILTER_SHOW_FILTERILTER_AUDIT";
export const FILTER_UPDATE_FILTER = "FILTER_UPDATE_FILTER";
export const FILTER_UPDATE_INPUT_FILTER = "FILTER_UPDATE_INPUT_FILTER";
export const FILTER_CLEAR_INPUT_FILTER = "FILTER_CLEAR_INPUT_FILTER";

export const showFilter = (module, open = false) => ({
  type: FILTER_SHOW_FILTER,
  payload: { module, open }
});

export const updateFilter = (module, filter = null) => ({
  type: FILTER_UPDATE_FILTER,
  payload: { module, filter }
});


export const updateInputFilter = (module, name, value) => ({
  type: FILTER_UPDATE_INPUT_FILTER,
  payload: { module, name, value }
});

export const clearInputFilter = (module, name) => ({
  type: FILTER_CLEAR_INPUT_FILTER,
  payload: { module, name }
});
